/**
 * Messages d'échec Import IA destinés à l'Admin (aucune donnée sensible).
 */

/**
 * @param {{ status?: string, errorMessage?: string|null, meta?: object|null }} job
 * @param {object|null|undefined} metaFallback
 * @returns {null | {
 *   statusLabel: string,
 *   errorMessage: string,
 *   explanation: string,
 *   rejectedNames: string[],
 * }}
 */
export function describeImportJobFailure(job, metaFallback) {
  if (!job || job.status !== 'FAILED') return null;

  const meta = job.meta || metaFallback || {};
  const grounding = meta.grounding || {};
  const rejectedNames = (grounding.rejectedNames || [])
    .filter((n) => typeof n === 'string' && n.trim() && n !== '(source)')
    .slice(0, 8);

  const errorMessage =
    (typeof job.errorMessage === 'string' && job.errorMessage.trim()) ||
    'L’analyse a échoué. Aucune donnée n’a été enregistrée.';

  let explanation =
    'L’import a été refusé pour protéger le catalogue. Vous pouvez réessayer avec une image plus nette ou un export PDF/tableur.';

  if (/absents du document source|n’existe pas dans le document source|n'existe pas dans le document source/i.test(errorMessage)) {
    explanation =
      'Des éléments proposés n’ont pas pu être vérifiés dans le document source. Aucune donnée inventée n’a été enregistrée.';
  } else if (/OCR|tessdata|deps/i.test(errorMessage) || String(meta.decision || '').startsWith('OCR_')) {
    explanation =
      'La lecture locale du document a échoué. Vérifiez le fichier (qualité, format) puis relancez l’analyse.';
  } else if (/Type produit accepte uniquement|colonne Unité accepte/i.test(errorMessage)) {
    explanation =
      'Corrigez le fichier Excel (colonnes Type produit et Unité), puis réimportez. Type produit = PHYSIQUE ou SERVICE ; les unités (KG, L…) vont dans la colonne Unité.';
  } else if (/sans texte source exploitable/i.test(errorMessage)) {
    explanation =
      'Impossible de contrôler le résultat faute de texte lisible dans la source. Aucune donnée inventée n’a été enregistrée.';
  } else if (/Cost cap|coût/i.test(errorMessage)) {
    explanation = 'Le plafond de coût d’analyse a été atteint. Réessayez plus tard ou contactez le support.';
  }

  return {
    statusLabel: 'Échec',
    errorMessage,
    explanation,
    rejectedNames,
  };
}

export default describeImportJobFailure;
